import { render } from "./CubeView.vue?vue&type=template&id=615616ba&scoped=true&ts=true"
import script from "./CubeView.vue?vue&type=script&lang=ts"
export * from "./CubeView.vue?vue&type=script&lang=ts"

import "./CubeView.vue?vue&type=style&index=0&id=615616ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615616ba"]])

export default __exports__